import ConfirmDialog from './ConfirmDialog';

export * from './ConfirmDialog';

export default ConfirmDialog;
